export const LOGO =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_mb-notary-luxury/artifacts/39rmne40_A73E493C-891D-4337-99E8-8E1809392119.PNG";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1518674660708-0e2c0473e68e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMGRvY3VtZW50JTIwZ29sZCUyMHBlbnxlbnwwfHx8fDE3ODIxNDU2MjR8MA&ixlib=rb-4.1.0&q=85";

export const SKYLINE_IMG =
  "https://images.unsplash.com/photo-1631548637245-043803a8b776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxjaGljYWdvJTIwc2t5bGluZSUyMGFyY2hpdGVjdHVyZSUyMG1pbmltYWx8ZW58MHx8fHwxNzgzOTgzMzYyfDA&ixlib=rb-4.1.0&q=85";

export const PHONE = "(312) 834-7170";
export const PHONE_HREF = "tel:+13128347170";
export const EMAIL = "mbaggett278@gmail.com";
export const EMAIL_HREF = "mailto:mbaggett278@gmail.com";

// Google review link. Update this to your exact "write a review" URL from your
// Google Business Profile for one-click reviews. Default opens a Google search
// for the business so clients can find and click "Write a review".
export const REVIEW_URL = "https://www.google.com/search?q=MB+Notary+Services+Chicago+reviews";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Service Area", href: "#service-area" },
  { label: "Contact", href: "#contact" },
];
